import { render, staticRenderFns } from "./DetailAnggota.vue?vue&type=template&id=6d4d008f&"
import script from "./DetailAnggota.vue?vue&type=script&lang=js&"
export * from "./DetailAnggota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports